<ul class="sc-nav-items__list" *ngIf="menu">
  <li *ngFor="let item of menu.items" class="sc-nav-items__list-item">
    <a
      *ngIf="!item.isMenu()"
      (click)="itemClicked.emit(item)"
      class="sc-nav-items__list-item-link"
      [ngClass]="{'sc-nav-items__list-item-link--selected': highlightActive && item.selected}"
      [attr.id]="item.id"
    >
      <sc-icon
        *ngIf="item.icon"
        class="sc-nav-items__list-item-icon"
        [icon]="item.icon" size="0_75"></sc-icon>
      <span
        *ngIf="!item.icon"
        class="sc-nav-items__list-item-icon-placeholder">
      </span>
      {{item.label}}
    </a>
    <sc-nav-submenu
      [ngClass]="{'internal-sub-menu': !firstLevel}"
      *ngIf="item.isMenu()"
      [highlightActive]="highlightActive"
      [firstLevel]="firstLevel"
      [menu]="item"
      (itemClicked)="itemClicked.emit($event)"
    >
    </sc-nav-submenu>
  </li>
</ul>
